import { IVehicle } from '../../../../schema/Vehicle.ts';
import { VehicleBadge } from '../../../ui/Badge.tsx';
import { Battery } from '../Battery.tsx';
import { OccupiedSeats } from '../OccupiedSeats.tsx';

export function InOperation(props: Readonly<{ vehicle: IVehicle }>) {
  return (
    <>
      <div className={'d-flex gap-3 align-items-center'}>
        <VehicleBadge vehicle={props.vehicle} />
        <p className={'card-text'}>{props.vehicle.display_identifier}</p>
      </div>
      <div className={'d-flex gap-3 align-items-center mt-2'}>
        <Battery batteryLevel={Number(props.vehicle.charge_percentage)} />
        <OccupiedSeats vehicle={props.vehicle} />
        <p className={'text-basic'}>{props.vehicle.provider}</p>
      </div>
    </>
  );
}
